import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-contact">
          <a href="mailto:sky.italia2023@gmail.com" className="footer-link">
            <Mail size={20} />
            <span>sky.italia2023@gmail.com</span>
          </a>
          <a href="tel:+393314492862" className="footer-link">
            <Phone size={20} />
            <span>+39 331 449 2862</span>
          </a>
        </div>

        <nav className="footer-legal" aria-label="Legali">
          <Link to="/privacy-policy" className="footer-legal-link" data-testid="footer-privacy">{t('footer.privacy')}</Link>
          <span className="footer-sep">·</span>
          <Link to="/cookie-policy" className="footer-legal-link" data-testid="footer-cookie">{t('footer.cookies')}</Link>
          <span className="footer-sep">·</span>
          <Link to="/termini-condizioni" className="footer-legal-link" data-testid="footer-termini">{t('footer.termini')}</Link>
        </nav>

        <div className="footer-disclaimer">
          <p>{t('footer.disclaimer')}</p>
        </div>

        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
